export default __webpack_public_path__ + "2fe2b5ca5a1c521527e7791d7f773f8c.ttf";